export const loadMore = () => {
    const $ = jQuery;

    const loadMoreButton = $('#load-more-trigger');

    if (loadMoreButton.length === 0) {
        return true;
    }

    const handleLoadMoreClick = (e) => {
        e.preventDefault();

        const data = loadMoreButton.data();

        $.ajax({
            url: wpApiSettings.root + 'ans/v1/posts',
            method: 'GET',
            data,
            success: (response) => {
                if (response.html) {
                    $('#posts-wrapper').append(response.html);
                }
                if (response.more_posts) {
                    loadMoreButton.data('page', response.args.paged + 1);
                } else {
                    loadMoreButton.remove();
                }
            },
            error: (response) => {loadMoreButton.remove();}
        });
    }

    loadMoreButton.on('click', handleLoadMoreClick);
};